var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import ComponentForm from '../ComponentForm';
import { multiSelectFormStyles } from './MultiSelectForm.style';
/**
 * MultiSelectForm component
 */
var MultiSelectForm = /** @class */ (function (_super) {
    __extends(MultiSelectForm, _super);
    /**
     * MultiSelectForm constructor
     * @param props
     */
    function MultiSelectForm(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Handle selection
         * @param evt
         */
        _this.handleSelectChange = function (evt) {
            evt.persist();
            _this.setState({ value: evt.target.value });
            _this.props.onChange('keyValue', [_this.props.id, evt.target.value]);
        };
        /**
         * Handle close
         */
        _this.handleClose = function () {
            _this.props.onChange('keyValue', [_this.props.id, _this.state.value]);
        };
        _this.renderChip = _this.renderChip.bind(_this);
        _this.getLabel = _this.getLabel.bind(_this);
        _this.state = { value: _this.props.initialValue || [] };
        return _this;
    }
    /**
     * Component update actions
     * @param props
     */
    MultiSelectForm.prototype.componentDidUpdate = function (props) {
        if (JSON.stringify(this.props.options) !== JSON.stringify(props.options)) {
            this.setState({ value: [] });
        }
        if (props.reset !== this.props.reset && this.props.reset) {
            this.setState({ value: [] });
        }
    };
    /**
     * MultiSelectForm render method
     */
    MultiSelectForm.prototype.render = function () {
        var _a = this.props, id = _a.id, label = _a.label, options = _a.options, error = _a.error, classes = _a.classes, helperText = _a.helperText, visible = _a.visible, required = _a.required;
        var value = this.state.value;
        if (!visible) {
            return null;
        }
        return React.createElement(FormControl, { fullWidth: true, required: required, className: classes.formControl, margin: "normal", error: error },
            React.createElement(InputLabel, { htmlFor: "select-multiple" }, label),
            React.createElement(Select, { multiple: true, value: value, name: id, onChange: this.handleSelectChange, input: React.createElement(Input, { id: "select-multiple-" + id }), onClose: this.handleClose, renderValue: this.renderChip }, options.map(function (option) { return (React.createElement(MenuItem, { key: option.value, value: option.value },
                React.createElement(Checkbox, { checked: option.value ? value.indexOf(option.value) > -1 : false }),
                React.createElement(ListItemText, { primary: option.label }))); })),
            error
                ? React.createElement(FormHelperText, null, helperText)
                : null);
    };
    /**
     * Render chip method for display choices
     * @param value
     */
    MultiSelectForm.prototype.renderChip = function (value) {
        var _this = this;
        return React.createElement("div", { className: this.props.classes.chips }, value.map(function (val) { return (React.createElement(Chip, { key: val, label: _this.getLabel(val), className: _this.props.classes.chip })); }));
    };
    /**
     * Return label for param value
     * @param value
     */
    MultiSelectForm.prototype.getLabel = function (value) {
        var option = this.props.options.find(function (opt) { return opt.value === value; });
        if (option) {
            return option.label;
        }
        return value;
    };
    return MultiSelectForm;
}(ComponentForm));
export default withStyles(multiSelectFormStyles)(MultiSelectForm);
//# sourceMappingURL=MultiSelectForm.js.map